import Vue from 'vue'
import VueAnimationTimeline from 'vue-animation-timeline'

Vue.use(VueAnimationTimeline)
